module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-player"
  }, [_c('video', {
    staticClass: "video-js vjs-custom-skin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75e08844"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-video-player/player.vue
// module id = 175
// module chunks = 81